/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";
import type FileAttachment from "parog-web/models/file-attachment";
import type SemeiaSessionService from "parog-web/services/session";

import styles from "./index.module.css";

interface Signature {
  Args: {
    isFromHprim?: unknown;
    validationStatus?: unknown;
    retrievedJournalEvent: BioExamResultsReceivedJournalEvent;
  };
}

export default class BioExamResultsAdditionalInformationsComponent extends Component<Signature> {
  styles = styles;

  @service
  declare session: SemeiaSessionService;

  get origin(): string {
    const origin = window.location.origin;

    if (origin.includes("localhost")) {
      return origin.replace("4200", "3000");
    }

    return origin;
  }

  get fileAttachmentUrl(): string {
    return `${this.origin}/api/v1/file-attachments/`;
  }

  get hprimUrl(): string {
    return `${this.origin}/api/v1/hprims/`;
  }

  get lastFileAttachment(): FileAttachment | undefined {
    return this.args.retrievedJournalEvent.orderedFileAttachments.at(-1);
  }

  get otherFileAttachments(): FileAttachment[] | undefined {
    return this.args.retrievedJournalEvent.orderedFileAttachments.slice(0, -1);
  }
}
